export const TetraResourcesState = {
    isLoading: false,
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
    statusCode:'',
    tetraResourceList:[]
}